import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Button, makeStyles } from '@fluentui/react-components';
import { ArrowLeft20Filled } from '@fluentui/react-icons';

const useStyles = makeStyles({
  backwardButtonContainer: {
    width: '649px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    '@media (max-width: 1250px)': {
      width: '445px',
    },
  },
  backwardButton: {
    padding: '3px 0px',
  },
});

const BackButtonComponent = (props) => {
  const { onBackButtonClick } = props;
  const classes = useStyles();

  return (
    <div className={classnames('back-button', classes.backwardButtonContainer)}>
      <Button
        className={classes.backwardButton}
        appearance="subtle"
        icon={<ArrowLeft20Filled />}
        onClick={onBackButtonClick}
      >
        Back to search results
      </Button>
    </div>
  );
};

BackButtonComponent.propTypes = {
  onBackButtonClick: PropTypes.func.isRequired,
};

export const BackButton = BackButtonComponent;
